import React from 'react'
import '../Styles/World_visiting_place.css'
import worldImage from '../Images/visiting_place_world.png'
import RightArrowIcon from '../Images/ArrowCircleRight.png'
import { useNavigate } from 'react-router-dom'
import Miron_da_vdo from '../Images/miron_da_video.mp4'

function World_visiting_place() {
  const navigate = useNavigate();

  return (
    <div className='World_visiting_place'>

      {/* 🎥 Miron Da Video */}
      <div className="miron_da_video">
        <video
          src={Miron_da_vdo}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>
<button className='explore_btn' onClick={() => navigate('/tour/packagetour')}>
        Explore Now
        <img src={RightArrowIcon} alt="Right Arrow" className="right-arrow-icon" />
      </button>
    </div>
  )
}

export default World_visiting_place
